import HttpWrapper from '@/utils/http/httpWrapper'

import ShipbobAppSettings from '../../appSettings/appSetting'

export const INVENTORY_DISTRIBUTION_API = ShipbobAppSettings.inventoryDistributionApiUrl

class InventoryDistributionServiceInternal {
  urls () {
    return {
      getAvailableWroDestinationsForSourceHub: INVENTORY_DISTRIBUTION_API + '/api/v2/receiving/{hubFcId}/locations'
    }
  }

  async getAvailableWroDestinationsForSourceHub (hubFcId) {
    const request = {
      Url: this.urls().getAvailableWroDestinationsForSourceHub.replace('{hubFcId}', hubFcId)
    }

    return await HttpWrapper.Get(request)
  }
}

export const InventoryDistributionService = new InventoryDistributionServiceInternal()
